// Client-side CSV export helper (Q10 — DESIGN-DECISIONS-2026-05-01).
// Exports the rows passed in. No pagination awareness — exports current page only.

interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number | null | undefined;
}

function escape(cell: string): string {
  if (cell.includes(",") || cell.includes("\"") || cell.includes("\n")) {
    return `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
}

export function downloadCsv<T>(filename: string, columns: ReadonlyArray<CsvColumn<T>>, rows: readonly T[]): void {
  const header = columns.map((c) => escape(c.header)).join(",");
  const body = rows
    .map((r) => columns.map((c) => {
      const v = c.value(r);
      return escape(v == null ? "" : String(v));
    }).join(","))
    .join("\n");
  const csv = `${header}\n${body}\n`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export type { CsvColumn };
